module.exports = __webpack_public_path__ + "static/media/individual-goal.0d7f1ff6.svg";